import { GENERATE_CUSTOMER_VOUCHER_FAILED_HANDLER } from "../actions/types";

export default (state = {}, action) => {
  switch (action.type) {
    case GENERATE_CUSTOMER_VOUCHER_FAILED_HANDLER:
      return action.payload;
    default:
      return state;
  }
};
